module.exports = __webpack_public_path__ + "right.a7b6e48b.png";